import React from 'react'
import { Text } from 'rebass'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'

export const EditPerformanceCell = (cellParams: GridRenderCellParams): React.ReactElement => {
    if (cellParams.value === undefined) return <></>
    const { uuid } = cellParams.row
    const isEditing = cellParams.value.editingSubmissionPerformance
        ? uuid === cellParams.value.editingSubmissionPerformance.submissionUuid
        : false
    if (isEditing) {
        const updatePerformance = (event: React.FocusEvent) =>
            cellParams.value.handlePerformanceUpdate(event, cellParams.value.taskUuid, cellParams.value.performanceKey)
        const onKeyDown = (event: React.KeyboardEvent) => {
            event.stopPropagation()
        }
        return (
            <input
                style={{ width: '100%' }}
                type="number"
                defaultValue={cellParams.value.value || undefined}
                onBlur={updatePerformance}
                onKeyDown={onKeyDown}
            />
        )
    }
    return <Text>{cellParams.value.value}</Text>
}
